import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import moment from 'moment';
class NotificationWeblinkReact extends Component {
    static $inject = ['props'];
    constructor(props) {
        super(props);
        this.state = {
            date: this.getDate(props.notification.date),
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.notification.date !== this.props.notification.date) {
            this.setState({ date: this.getDate(this.props.notification.date) });
        }
    }
    getDate(notificationDate) {
        const today = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        const yesterdayEnd = moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        const yesterdayStart = moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        if (notificationDate >= today) {
            return `Hoje - ${moment(notificationDate).format('HH:mm')}`;
        }
        if (notificationDate < yesterdayEnd && notificationDate > yesterdayStart) {
            return `Ontem - ${moment(notificationDate).format('HH:mm')}`;
        }
        return `${moment(notificationDate).format('DD/MM/YYYY')} - ${moment(notificationDate).format('HH:mm')}`;
    }
    render() {
        const { notification } = this.props;
        const { date } = this.state;
        return (_jsxs("div", { children: [_jsxs("a", { href: notification.content.uri, className: "bp-lh-simple", target: notification.content.target, onClick: this.props.onConsume, children: [_jsx("div", { className: "notification-title", dangerouslySetInnerHTML: { __html: notification.content.title } }), _jsx("bds-typo", { "data-test": "typoTextNotificationTest", className: "color-neutral-dark-city", bold: notification.status === 'received' ? 'bold' : undefined, variant: "fs-16", tag: "p", children: notification.content.text })] }), _jsxs("bds-typo", { "data-test": "typoDateNotificationTest", className: "color-neutral-dark-city", variant: "fs-10", tag: "p", children: [date, " ", notification.status !== 'received' && this.props.$translate.instant('notificationsCenter.received')] })] }));
    }
}
export default NotificationWeblinkReact;
